<div class="sgt-canal-midia-social-input-group">
    <div class="input-group">
        <div class="input-group-prepend">
            <span class="input-group-text">
                <i class="{{canalMidiaSocial | canalMidiaSocialIcon}}"></i>
            </span>
        </div>
        <input type="text" class="form-control" [value]="canalMidiaSocial | canalMidiaSocial" disabled="disabled" readonly="readonly" title="{{canalMidiaSocial | canalMidiaSocial}}">
    </div>
</div>